"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaToJsText = exports.deepMergeSchema = exports.fixSchemaSimple = exports.prefixSchemaSimple = exports.defineSchemaSimple = exports.predefineSchemaSimple = exports.fixSchema = exports.prefixSchema = exports.defineSchema = exports.predefineSchema = exports.mergeSchema = exports.compileFunctions = exports.omitFuncText = exports.isObject = exports.isFunction = void 0;
var schemaMethods_1 = require("../schemaMethods");
var schemaFuncText_1 = require("./schemaFuncText");
// skopiowane z @vue/shared
/**
 * Sprawdza czy zmienna jest funkcją.
 * @param val
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
var isFunction = function (val) { return typeof val === 'function'; };
exports.isFunction = isFunction;
/**
 * Sprawdza czy zmienna jest obiektem.
 * @param val
 * @returns
 */
var isObject = function (val) { return val !== null && typeof val === 'object'; };
exports.isObject = isObject;
exports.omitFuncText = new Set([]);
var shortCalcFields = new Set([
    'enum',
    'calc',
    'fieldRequired',
    'readOnly',
    'disabled',
    'minimum',
    'maximum',
    'exclusiveMaximum',
    'exclusiveMinimum',
    'precision',
    'maxItems',
    'minItems',
    'maxLength',
    'minLength'
]);
/**
 * Kompiluje funkcje ale omija items i pojedyncze properties.
 * @param schema schemat
 * @returns
 */
function compileFunctions(schema, options) {
    if (options === void 0) { options = {}; }
    if (schema.$alreadyCompiled)
        return schema;
    for (var key in schema) {
        var keyValue = schema[key];
        switch (key) {
            case '$ref':
                // options.isRef = true;
                break;
            case '$external':
            case '$parent':
            case '$parent2':
            case '$parent3':
            case '$root':
                delete schema[key];
                break;
            case '$methods':
                if ((0, exports.isObject)(keyValue)) {
                    for (var methodName in keyValue) {
                        var method = keyValue[methodName];
                        if ((0, exports.isFunction)(method)) {
                            var mobj = {
                                body: (0, schemaFuncText_1.schemaFuncText)(method, { skipRemoveReturn: true, removeDebugger: options.removeDebugger })
                            };
                            // jeśli są atrybuty
                            if (method.length) {
                                var s = method.toString();
                                var p = s.indexOf('(');
                                if (p > -1) {
                                    var p2 = s.indexOf(')', p);
                                    mobj.args = s.substring(p + 1, p2);
                                }
                                keyValue[methodName] = mobj;
                            }
                            else {
                                keyValue[methodName] = mobj.body;
                            }
                        }
                    }
                }
                break;
            case 'properties':
                if (schema.type !== 'object') {
                    delete schema[key];
                    schema.type = 'object';
                    schema[key] = keyValue;
                }
                for (var prop in keyValue) {
                    var propVal = keyValue[prop];
                    if ((0, exports.isFunction)(propVal)) {
                        var propValRes = propVal();
                        compileFunctions(propValRes, options);
                        keyValue[prop] = propValRes;
                    }
                    else if ((0, exports.isObject)(propVal)) {
                        compileFunctions(propVal, options);
                    }
                }
                break;
            case 'items':
                if (schema.type !== 'array') {
                    delete schema[key];
                    schema.type = 'array';
                    schema[key] = keyValue;
                }
                if ((0, exports.isFunction)(keyValue)) {
                    var itemsValRes = keyValue();
                    compileFunctions(itemsValRes, options);
                    schema[key] = itemsValRes;
                }
                else if ((0, exports.isObject)(keyValue)) {
                    compileFunctions(keyValue, options);
                }
                break;
            default:
                if ((0, exports.isFunction)(keyValue)) {
                    if (!exports.omitFuncText.has(key)) {
                        schema[key] = (0, schemaFuncText_1.schemaFuncText)(keyValue, {
                            skipRemoveReturn: !shortCalcFields.has(key),
                            removeDebugger: options.removeDebugger
                        });
                    }
                }
                else if ((0, exports.isObject)(keyValue)) {
                    if (key === 'allOf') {
                        // options.isAllOf = true;
                    }
                    compileFunctions(keyValue, options);
                }
        }
    }
    return schema;
}
exports.compileFunctions = compileFunctions;
/**
 * Kompiluje funkcje w schemacie i zaznacza zeby powtórnie go nie kompilować (użyteczne przy zagnieżdzaniu schematów ).
 * @param schema
 * @returns
 */
function compileFunctionsAndMark(schema) {
    /*
      var opts = {
          isRef: false,
          isAllOf: false
      }
      */
    var schema2 = compileFunctions(schema);
    Object.defineProperty(schema2, '$alreadyCompiled', {
        value: true,
        enumerable: false
    });
    return schema2;
}
function mergeSchema() {
    var schemas = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        schemas[_i] = arguments[_i];
    }
    return deepMergeSchema(schemas);
}
exports.mergeSchema = mergeSchema;
var PredefineSchema = /** @class */ (function () {
    function PredefineSchema(root, external, methods, skipCompile) {
        if (skipCompile) {
            this.fixSchema = this.defineSchemaSimple;
            this.defineSchema = this.defineSchemaSimple;
        }
    }
    //@ts-ignore
    PredefineSchema.prototype.defineSchema = function () {
        var schemas = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            schemas[_i] = arguments[_i];
        }
        if (schemas.length == 1)
            return compileFunctionsAndMark(schemas[0]);
        return compileFunctionsAndMark(deepMergeSchema(schemas));
    };
    PredefineSchema.prototype.defineSchemaSimple = function () {
        var schemas = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            schemas[_i] = arguments[_i];
        }
        if (schemas.length == 1)
            return schemas[0];
        return deepMergeSchema(schemas);
    };
    PredefineSchema.prototype.fixSchema = function () {
        var schemas = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            schemas[_i] = arguments[_i];
        }
        return compileFunctionsAndMark(deepMergeSchema(schemas));
    };
    return PredefineSchema;
}());
/**
 * Predefinicja schematu, umożliwia ustawienie typu $root, $external i $methods.
 * @param $root
 * @param $external
 * @param $methods
 * @returns
 */
function predefineSchema($root, $external, $methods) {
    return new PredefineSchema($root || {}, $external || {}, $methods || {}, false).defineSchema;
}
exports.predefineSchema = predefineSchema;
/**
 * Definicja schematu bez typowania.
 */
exports.defineSchema = predefineSchema();
/**
 * Predefinicja funkcji fix która zmienia schemat bez zmiany zwracanego typu.
 * @param $root
 * @param $external
 * @param $methods
 * @returns
 */
function prefixSchema($root, $external, $methods) {
    return new PredefineSchema($root || {}, $external || {}, $methods || {}, false).fixSchema;
}
exports.prefixSchema = prefixSchema;
/**
 * Funkcja zmieniająca schemat bez zmiany typu.
 */
exports.fixSchema = prefixSchema();
/**
 * Predefinicja schematu bez kompilacji funkcji, umożliwia ustawienie typu $root, $external i $methods.
 * @param $root
 * @param $external
 * @param $methods
 * @returns
 */
function predefineSchemaSimple($root, $external, $methods) {
    return new PredefineSchema($root || {}, $external || {}, $methods || {}, true).defineSchema;
}
exports.predefineSchemaSimple = predefineSchemaSimple;
/**
 * Definicja schematu bez typowania i kompilacji funkcji.
 */
exports.defineSchemaSimple = predefineSchemaSimple();
/**
 * Predefinicja funkcji fix która zmienia schemat bez zmiany zwracanego typu i bez kompilacji funkcji.
 * @param $root
 * @param $external
 * @param $methods
 * @returns
 */
function prefixSchemaSimple($root, $external, $methods) {
    return new PredefineSchema($root || {}, $external || {}, $methods || {}, true).fixSchema;
}
exports.prefixSchemaSimple = prefixSchemaSimple;
/**
 * Funkcja zmieniająca schemat bez zmiany typu i kompilacji funkcji.
 */
exports.fixSchemaSimple = prefixSchemaSimple();
/**
 * Funkcja do głebokiego łączenia schematów.
 * @param items
 * @returns
 */
function deepMergeSchema(items) {
    var mergeProps = {};
    var res = {};
    // const starProps: any[] = [];
    for (var i = 0; i < items.length; i++) {
        var item = items[i];
        for (var key in item) {
            var value = item[key];
            if (key === '_' || key === '*') {
                // czy są określone pola jakich dotyczy łaczenie ?
                if (value.$fields) {
                    var starProps = [];
                    var starFields = value.$fields;
                    // jeśli funkcja to wykonać
                    if ((0, exports.isFunction)(starFields)) {
                        starFields = starFields.call(mergeProps);
                    }
                    if (Array.isArray(starFields)) {
                        for (var _i = 0, starFields_1 = starFields; _i < starFields_1.length; _i++) {
                            var starItem = starFields_1[_i];
                            if (typeof starItem === 'string') {
                                starItem = mergeProps[starItem];
                            }
                            if (starItem)
                                starProps.push(starItem);
                        }
                    }
                    delete value.$fields;
                    for (var _a = 0, starProps_1 = starProps; _a < starProps_1.length; _a++) {
                        var propArray = starProps_1[_a];
                        propArray.push(value);
                    }
                }
                else {
                    for (var key_1 in mergeProps) {
                        var propArray = mergeProps[key_1];
                        propArray.push(value);
                    }
                }
            }
            else if (value === undefined) {
                delete mergeProps[key];
                delete res[key];
            }
            else if (key === 'default') {
                res[key] = value;
            } /* else if (value === null) {
                      delete mergeProps[key];
                      delete res[key];
                  } */
            else if (Array.isArray(value)) {
                delete mergeProps[key];
                res[key] = value;
            }
            else if ((0, exports.isFunction)(value)) {
                delete mergeProps[key];
                res[key] = value;
            }
            else if ((0, exports.isObject)(value)) {
                var propArray = mergeProps[key];
                if (propArray == undefined) {
                    propArray = [];
                    mergeProps[key] = propArray;
                }
                propArray.push(value);
            }
            else {
                delete mergeProps[key];
                res[key] = value;
            }
        }
    }
    /*
      let starProp = null;
      if (starProps.length) {
          if (starProps.length>1) {
              starProp = deepMergeSchema
          }
      }
      */
    for (var key in mergeProps) {
        var propArray = mergeProps[key];
        if (propArray.length == 1) {
            res[key] = propArray[0];
        }
        else {
            res[key] = deepMergeSchema(propArray);
        }
    }
    return res;
}
exports.deepMergeSchema = deepMergeSchema;
function _schemaToJsText(schemaDef) {
    var json = JSON.stringify(schemaDef, function (key, value) {
        if (typeof value === 'function') {
            return '[FUNCTION]' + value;
        }
        return value;
    }, '  ');
    var moduleJavascript = json.replace(/"(\[FUNCTION])?((?:\\.|[^\\"])*)"(:)?/g, function (match, group1, group2, group3) {
        if (group1)
            return JSON.parse('"FUNCTION' + group2 + '"');
        //if (group1) return JSON.parse('"' + group2 + '"');
        if (group3 && /^\w+$/.test(group2))
            return group2 + ':';
        return match;
    });
    //moduleJavascript = moduleJavascript.replace(/(\b\w+\b):\s*FUNCTION\1\s*\(/g, (match, group1) => {
    // add: FUNCTIONadd(    | add: FUNCTION(  |
    //moduleJavascript = moduleJavascript.replace(/(\b\w+\b):\s*FUNCTION(\1\s*|s*)\(/g, (match, group1) => {
    //add: FUNCTIONadd()  | add: FUNCTIONfunction add()
    moduleJavascript = moduleJavascript.replace(/(\b\w+\b):\s*FUNCTION(function\s)?\1\s*\(/g, function (match, group1) {
        if (group1)
            return group1 + '(';
        return match;
    });
    //add: FUNCTION() =>
    moduleJavascript = moduleJavascript.replace(/(\b\w+\b):\s*FUNCTION\s*\(/g, function (match, group1) {
        if (group1)
            return group1 + ': (';
        return match;
    });
    return moduleJavascript;
}
/**
 * Zamienia schemat na tekst JS.
 * @param schemaDef definicja schematu
 * @param replaceMethodsEnums czy zamieniać enumy z $methods na ich wartości
 * @returns
 */
function schemaToJsText(schemaDef, replaceMethodsEnums, removeThis) {
    if (replaceMethodsEnums === void 0) { replaceMethodsEnums = true; }
    if (removeThis === void 0) { removeThis = true; }
    var methodsEnums = {};
    var removedEnums = {};
    if (replaceMethodsEnums && schemaDef.$methods) {
        for (var key in schemaDef.$methods) {
            var isEnum = false;
            var val = schemaDef.$methods[key];
            if (!(0, exports.isFunction)(val)) {
                isEnum = true;
                if ((0, exports.isObject)(val)) {
                    for (var skey in val) {
                        var vval = val[skey];
                        if ((0, exports.isFunction)(vval) || (0, exports.isObject)(vval)) {
                            isEnum = false;
                        }
                        else {
                            methodsEnums[key + '.' + skey] = JSON.stringify(vval) + ' /* this.$methods.' + key + '.' + skey + ' */';
                        }
                    }
                }
                else {
                    // po prostu wartość
                    methodsEnums[key] = JSON.stringify(val) + ' /* this.$methods.' + key + ' */';
                }
            }
            if (isEnum) {
                removedEnums[key] = schemaDef.$methods[key];
                delete schemaDef.$methods[key];
            }
        }
        // usuniecie $methods ze schematu jeśli jest już jest puste
        if (Object.keys(schemaDef.$methods).length == 0) {
            delete schemaDef.$methods;
        }
    }
    var fixSimpleThis = false;
    if (removeThis) {
        if (!schemaDef.$options) {
            schemaDef.$options = {};
        }
    }
    var moduleJavascript = _schemaToJsText(schemaDef);
    if (replaceMethodsEnums) {
        // replace $methods enums for speed only
        for (var key in methodsEnums) {
            moduleJavascript = (0, schemaMethods_1.replaceAll)(moduleJavascript, 'this.$methods.' + key, methodsEnums[key]);
        }
        // restore removed $methods in schema
        for (var key in removedEnums) {
            if (!schemaDef.$methods) {
                schemaDef.$methods = {};
            }
            schemaDef.$methods[key] = removedEnums[key];
        }
    }
    return moduleJavascript;
}
exports.schemaToJsText = schemaToJsText;
exports.default = exports.defineSchema;
//# sourceMappingURL=defineSchema.js.map